module.exports = __webpack_public_path__ + "static/media/fullscreen-live-img.b441cd4c.svg";